import { Pipe, PipeTransform } from '@angular/core';
import { ArrayEditorItem } from '../models/array-editor-item.model';

@Pipe({
  name: 'arrayItemIndex',
})
export class ArrayItemIndexPipe implements PipeTransform {
  transform(item: ArrayEditorItem, index: number, last: boolean): ArrayEditorItem {
    if (!item) {
      return null;
    }
    item.index = index;
    item.first = index === 0;
    item.last = last;
    return item;
  }
}
